import VersionNumber from './importer/VersionNumber';

export default {
  LAST_SUPPORTED_FREEMIND_VERSION: '1.0.1',

  SUPPORTED_FREEMIND_VERSION: new VersionNumber('1.0.1'),

  CODE_VERSION: 'tango',

  SECOND_LEVEL_TOPIC_HEIGHT: 25,

  ROOT_LEVEL_TOPIC_HEIGHT: 25,

  CENTRAL_TO_TOPIC_DISTANCE: 200,

  TOPIC_TO_TOPIC_DISTANCE: 90,

  FONT_SIZE_HUGE: 15,

  FONT_SIZE_LARGE: 10,

  FONT_SIZE_NORMAL: 8,

  FONT_SIZE_SMALL: 6,

  NODE_TYPE: 'NODE',

  BOLD: 'bold',

  ITALIC: 'italic',

  EMPTY_FONT_STYLE: ';;;;;',

  EMPTY_NOTE: '',

  POSITION_LEFT: 'left',

  POSITION_RIGHT: 'right',
};
